import * as React from "react";
import { IOSWrapper, IOSItemWrapper, AndroidItemWrapper, AndroidWrapper, BottomBar } from "./pivot-header-style";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import { withTheme } from "styled-components";
import type { RenderEnvironment } from "common/components/types";

interface Props {
    items: string[];
    current: number;
    onClick: (index: number) => void;
    theme: RuntimeTheme;
    renderEnvironment: RenderEnvironment;
}
interface State {}

class PivotHeader extends React.PureComponent<Props, State> {
    public state: State = {};

    public render(): React.ReactNode {
        const { items, onClick, current, theme, renderEnvironment } = this.props;

        let MainWrapper = IOSWrapper;
        let ChildWrapper = IOSItemWrapper;
        let bar: React.ReactNode;

        if (theme.pivot.style === "TopTabs") {
            MainWrapper = AndroidWrapper;
            ChildWrapper = AndroidItemWrapper;

            const width = 100 / items.length;
            const position = 100 * current;

            bar = <BottomBar width={`${width}%`} position={`${position}%`} />;
        }

        const inTabletDetail =
            renderEnvironment.sizeClass === "tablet" && renderEnvironment.displayContext === "detail";

        const children = items.map((val, index) => {
            return (
                <ChildWrapper
                    data-test="app-pivot-header-item"
                    key={index}
                    onClick={() => onClick(index)}
                    isCurrent={index === current}>
                    {val}
                </ChildWrapper>
            );
        });

        return (
            <MainWrapper data-test="app-pivot-header" isTabletDetail={inTabletDetail}>
                {children}
                {bar}
            </MainWrapper>
        );
    }
}

export default withTheme(PivotHeader);
